import cImg1 from '../images/blog/video-thumb.jpeg'





const caseStudies = [
    { id: 1, category: "cat1", img: cImg1, title: "You are easier to hack than your computer: Social Engineering marvel", slug: "https://youtu.be/xEdZwLRJttQ?feature=shared" },
    // { id: 2, category: "cat1", img: cImg2, title: "Jaguar Land Rover Admits Data Breach Caused by Recent Cyberattack", slug: "https://www.securityweek.com/jaguar-land-rover-admits-data-breach-caused-by-recent-cyberattack/" },
    // { id: 3, category: "cat1", img: cImg3, title: "Drones and cyber outages exposing aviation weak spots since 2017", slug: "https://www.reuters.com/business/aerospace-defense/drones-cyber-outages-exposing-aviation-weak-spots-since-2017-2025-09-23/" },
    // { id: 4, category: "cat1", img: cImg4, title: "Design system & UI kit..", slug: "Design" },
    // { id: 5, category: "cat1", img: cImg5, title: "Offline SEO marketing..", slug: "Development" },
    // { id: 6, category: "cat1", img: cImg6, title: "IT security enhancement..", slug: "Support" },
   ];
export default caseStudies;